import { ReactNode } from "react";
import ColdwellBankerIcon from "../components/icons/ColdwellBankerIcon";
import CorcoranGroupIcon from "../components/icons/CorcoranGroupIcon";
import CompassIcon from "../components/icons/CompassIcon";
import { coldwellBankerTheme, compassTheme, corcoranGroupTheme, sothebysTheme, warburgTheme } from "./BrandTheme";
import SothebysIcon from "../components/icons/sothebysIcon";
import WarburgCBR from "../components/icons/WarburgCBR";
import BainCBR from "../components/icons/BainCBR";

export interface BrandConfig {
  key: string;
  primary: unknown;
  name: string;
  logo: ReactNode;
  theme: typeof coldwellBankerTheme | typeof warburgTheme;
  fontFamily: string;
  supportEmail: string;
}

export const brands: Record<string, BrandConfig> = {
  coldwellbanker: {
  key: 'coldwellbanker',
    primary: coldwellBankerTheme.colors.primary,
    name: "Coldwell Banker",
    logo: <ColdwellBankerIcon width={150} height={20} color="#1e3a8a" />,
    theme: coldwellBankerTheme,
    fontFamily: "'Work Sans', sans-serif",
    supportEmail: "support@coldwellbanker.com",
  },
  sothebys: {
  key: 'sothebys',
    primary: sothebysTheme.colors.primary,
    name: "Sothebys International Realty",
    logo: <SothebysIcon width={150} height={20} color="#1e3a8a" />,
    theme: sothebysTheme,
    fontFamily: "'Work Sans', sans-serif",
    supportEmail: "support@sothebys.com",
  },
  corcorangroup: {
  key: 'corcorangroup',
    primary: corcoranGroupTheme.colors.primary,
    name: "Corcoran Group",
    logo: <CorcoranGroupIcon />,
    theme: corcoranGroupTheme,
    fontFamily: "'Work Sans', sans-serif",
    supportEmail: "support@corcorangroup.com",
  },
  warburg: {
  key: 'warburg',
    primary: warburgTheme.colors.primary,
    name: "Christie's International Real Estate",
    logo: <WarburgCBR />,
    theme: warburgTheme,
    fontFamily: "'Work Sans', sans-serif",
    supportEmail: "support@coldwellbanker.com",
  },
  bain: {
  key: 'bain',
    primary: coldwellBankerTheme.colors.primary,
    name: "Coldwell Banker",
    logo: <BainCBR />,
    theme: coldwellBankerTheme,
    fontFamily: "'Work Sans', sans-serif",
    supportEmail: "support@coldwellbanker.com",
  },
  compass: {
  key: 'compass',
    primary: compassTheme.colors.primary,
    name: "Compass",
    logo: <CompassIcon width={150} height={20} color="#ffffff" />,
    theme: compassTheme,
    fontFamily: "'Work Sans', sans-serif",
    supportEmail: "support@compass.com",
  },
  // anotherbrand: {
  //   name: 'Another Brand',
  //   logo: <AnotherBrandIcon width={150} height={20} color="#E00034" />,
  //   theme: { ...anotherBrandTheme },
  //   fontFamily: "'Roboto', sans-serif",
  //   supportEmail: 'support@anotherbrand.com',
  // },
};
